import React, { ReactElement } from 'react';
import { observer } from 'src/utils/mobx-react';
import { Button } from 'src/domains/common/components/button/button';
import { useAppStateContext } from 'src/AppState/AppState';
import { BetTickerBox } from './BetTickerBox/BetTickerBox';
import { BetTickerV2State } from './BetTickerV2.state';
import { useCommon } from 'src/AppState/Common';

export const BetTickerV2 = observer('BetTickerV2', (): ReactElement => {
    const appState = useAppStateContext();
    const common = useCommon();
    const [state] = React.useState(() => new BetTickerV2State(common, appState.sdkStaff));
    const layout = appState.routerBackoffice.getParameter('global', 'layout');
    React.useEffect(() => {
        if (layout !== null && ['1', '2', '3', '4'].includes(layout)) {
            state.subscribeToBets();
            state.subscribeToRejectedBets();
            state.subscribeToSettledBets();

            const unsubscribeTimeout = setTimeout(() => {
                state.unsubscribeFromBets();
                state.unsubscribeFromRejectedBets();
                state.unsubscribeFromSettledBets();
            }, 3600000);

            return (): void => {
                state.unsubscribeFromBets();
                state.unsubscribeFromRejectedBets();
                state.unsubscribeFromSettledBets();
                clearTimeout(unsubscribeTimeout);
            };
        }
    }, [layout, state]);

    if (layout === '1')
        return (
            <div className='grid grid-cols-1 h-full max-h-[calc(100vh-72px)]'>
                <div className='h-[calc(100vh-72px)]'>
                    <BetTickerBox betTickerState={state} />
                </div>
            </div>
        );

    if (layout === '2')
        return (
            <div className='grid grid-cols-2 gap-4 h-full max-h-[calc(100vh-72px)]'>
                {[1, 2].map((num) => (
                    <div
                        key={num}
                        className='h-[calc(100vh-72px)]'
                    >
                        <BetTickerBox betTickerState={state} />
                    </div>
                ))}
            </div>
        );

    if (layout === '3')
        return (
            <div className='grid grid-cols-2 gap-4 h-full max-h-[calc(100vh-72px)]'>
                {[1, 2].map((num) => (
                    <div
                        key={num}
                        className='h-[calc((100vh-88px)/2)]'
                    >
                        <BetTickerBox betTickerState={state} />
                    </div>
                ))}
                <div className='h-[calc((100vh-88px)/2)] col-span-2'>
                    <BetTickerBox betTickerState={state} />
                </div>
            </div>
        );

    if (layout === '4')
        return (
            <div className='grid grid-cols-2 gap-4 h-full max-h-[calc(100vh-72px)]'>
                {[1, 2, 3, 4].map((num) => (
                    <div
                        key={num}
                        className='h-[calc((100vh-88px)/2)]'
                    >
                        <BetTickerBox betTickerState={state} />
                    </div>
                ))}
            </div>
        );

    return (
        <div className='flex flex-col gap-4 h-full items-center justify-center'>
            {['1', '2', '3', '4'].map((num) => {
                return (
                    <Button
                        variant='outline'
                        className='w-[320px] font-normal'
                        onClick={() => window.open(`/bet-tickerV2?layout=${num}`)}
                        key={num}
                    >
                        {num}
                    </Button>
                );
            })}
        </div>
    );
});
